import React from 'react'
import { object } from 'prop-types'

import VideoList from './VideoList'
import CampaignNameEditable from './CampaignNameEditable'

const Campaign = ({
  campaign
}) => {
  return (
    <div className='container'>
      <div className='row'>
        <div className='col-md-12'>
          <div className='page-header clearfix'>
            <h2>
              <CampaignNameEditable campaign={campaign} />
            </h2>
          </div>
        </div>
      </div>
      <div className='row'>
        <VideoList campaign={campaign} videos={campaign.videos} />
      </div>
    </div>
  )
}

Campaign.propTypes = {
  campaign: object
}

export default Campaign



// WEBPACK FOOTER //
// ./src/components/CampaignView.js